export const kauflandApp = {
  id: 324,
  name: "kaufland",
  label: "Kaufland",
  showTestConnection: true,
  logo: process.env.BASE_URL + "media/shopLogos/kaufland.png",
  areaBlacklist: ["migration", "reporting"],
  additional_params: {
    requestHeaders: {
      Accept: "application/json"
    },
    requestMethod: "GET",
    endpoint: "/categories?limit=1&storefront=de",
    authType: "kaufland-hmac"
  },
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_KAUFLAND_PRESET_ID,
    testWorkflows: {
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_KAUFLAND_TEST_BATCH_ORDER_WORKFLOW_ID,
      receipt: process.env?.VUE_APP_SCM_APP_TEST_BATCH_RECEIPT_WORKFLOW_ID
    },
    CFLDataSetId:
      process.env?.VUE_APP_SCM_APP_KAUFLAND_REPORTING_CFL_DATASET_ID,
    syncBatchWorkflowId:
      process.env.VUE_APP_SCM_APP_KAUFLAND_REPORTING_SYNC_BATCH_WORKFLOW_ID,
    shopImporterWorkflowId:
      process.env?.VUE_APP_SCM_APP_KAUFLAND_MIGRATION_SHOPIMPORTER_WORKFLOW_ID
  }
};
